export type TrackerMode = 'local' | 'api';
export type TrackerHistoryMode = 'local' | 'api';

export const TRACKER_MODE: TrackerMode = process.env.REACT_APP_TRACKER_MODE === 'api' ? 'api' : 'local';
export const TRACKER_HISTORY_MODE: TrackerHistoryMode =
	process.env.REACT_APP_TRACKER_HISTORY_MODE === 'api' || TRACKER_MODE === 'api' ? 'api' : 'local';

export const isTrackerApiMode = () => TRACKER_MODE === 'api';
export const isTrackerLocalMode = () => TRACKER_MODE === 'local';
export const isTrackerHistoryApiMode = () => TRACKER_HISTORY_MODE === 'api';